import React from 'react';
import { RiAddCircleFill, RiEditCircleFill, RiIndeterminateCircleFill } from 'react-icons/ri';
import { DELTA_CLASS_NAME } from '../../commons/fields/DeltaFieldUtils';

const DrugDeltaIcon = ({ showDelta, className }) => {
  const updatedClassName = className ? className + "-icon" : "";
  if (showDelta && updatedClassName) {
    if (className == DELTA_CLASS_NAME.NEW) {
      return <RiAddCircleFill className={updatedClassName} />
    } else if (className == DELTA_CLASS_NAME.DELETED) {
      return <RiIndeterminateCircleFill className={updatedClassName} />
    } else if (className == DELTA_CLASS_NAME.MODIFIED) {
      return <RiEditCircleFill className={updatedClassName} />
    }
  }
  return null
}

export default DrugDeltaIcon;